import React, {useState, useEffect} from "react";
import { Container, Row, Col } from "react-bootstrap";
import profile_img from "../../assets/PROFILE_IMG.png";
import recent from "../Sections/Art/images/VIEW_OF_THE_GREEN.png";

function Home() {
  const intro_blurb = {
    textAlign: 'justify',
    position: 'absolute',
    top: '40vh',
    fontSize: 'medium',
  };

  const content = {
    padding: '4rem 0 2rem 0',
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    textAlign: 'center',
    fontSize: '22px',
    gap: '0px',
    fontFamily: 'MyFont',
    fontWeight: 800,
    width: '50',
    height: '100vh',
    overflow: 'hidden',
  }
  
  const img_style = {
    maxWidth: '250px'
  }

  return (
    <section>
      <Container fluid className="home-section" >
        <Container style={content}>
          <div style={content}>
              <img src={profile_img} style={img_style}></img>
              <p>Sky Jung</p>
            </div>
        </Container>
      </Container>

      <Container fluid className="home-about-section">
        <Container className="home-about-container">
          <h2 className="home-about-heading">About</h2>
          <p className="home-about-text">
            <strong>Sky Jung</strong> (b. California) is a painter based in California whose work explores the relationship between perception, memory, and the construction of images. Working primarily in oil and acrylic, she creates paintings that emerge through cycles of accumulation, revision, and removal, revealing forms between recognition and abstraction. Drawing from a background in computer science and engineering, Jung's practice explores the subjective nature of human perception in resistance to technology's influence on how we see the world.
          </p>
          <p className="home-about-text">
            Jung received her A.B. from Harvard College in 2025, with a concentration in Computer Science and a secondary in Art, Film, and Visual Studies. Her work was included in the Art, Film, & Visual Studies: Open Studios 2025 at the Carpenter Center for the Visual Arts, Cambridge, MA, and the Open Call: Summer Show at Francis Gallery, Los Angeles (2026). She is also the founder of <a href="https://docentofficial.com" target="_blank" rel="noopener noreferrer">Docent</a>, a social museum and gallery guide connecting people with art in 150+ venues across 30 countries.
          </p>
        </Container>
      </Container>
    </section>
  );
}

export default Home;
